export default "__VITE_ASSET__HaswHgCS__"